import { render, staticRenderFns } from "./iristarModule.vue?vue&type=template&id=57384474&scoped=true&"
import script from "./iristarModule.vue?vue&type=script&lang=js&"
export * from "./iristarModule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57384474",
  null
  
)

export default component.exports